import { HttpClient, httpResource } from '@angular/common/http';
import { EnvironmentInjector, inject, Injectable, InputSignal, ModelSignal, runInInjectionContext, Signal, signal, WritableSignal, } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { ImpresoraDTO, GetImpresoraListResponse } from '../../../shared/models/generated';
import { readCookie, writeCookie } from '../../../shared/services/cookies-manager';
import { ModalService } from '../../../shared/services/modal.service';
import { PrinterSelectionDialog } from '../../../shared/components/printer-selection-dialog/printer-selection-dialog';
import { readLocalStorage, writeLocalStorage } from '../../../shared/services/session-manager';
import { PrinterTypes, PrinterTypesText } from '../../../shared/constants/printer-types';

@Injectable({
  providedIn: 'root'
})
export class ImpresorasService {
  [x: string]: any;
  printTestDocument(id: number, ancho?: null|string, alto?:null| string) {
    return this.http.get(`${environment.apiUrl}/api/impresoras/${id}/print-test-document`, {
      params: {
        ancho: ancho ?? "",
        alto: alto ?? ""
      }
    });
  }
  private readonly modalService = inject(ModalService);
  private injector = inject(EnvironmentInjector);

  delete(id: number | undefined) {
    return this.http.delete(`${environment.apiUrl}/api/impresoras/${id}`);
  }
  constructor(private http: HttpClient) { }
  update(dto: ImpresoraDTO | undefined) {
    return this.http.put(`${environment.apiUrl}/api/impresoras`, dto);
  }
  insert(dto: ImpresoraDTO | undefined) {
    return this.http.post(`${environment.apiUrl}/api/impresoras`, dto);
  }

  async configureImpresoras() {
    this.modalService.open(PrinterSelectionDialog);
  }


  async ensureDefaultPrinterSelected() {

    return runInInjectionContext(this.injector, async () => {


      let defaultPrinter = readLocalStorage(PrinterTypes.Predeterminada);
      if (defaultPrinter)
        return true;


      let dialog = this.modalService.open(PrinterSelectionDialog, {
      }, state => {
        state.defaultPrinterRequired.set(true);
      });
      return await dialog.result;

    });

  }


  async ensureGuiasEtiquetasSelected() {

    return runInInjectionContext(this.injector, async () => {


      let guiasPrinter = readLocalStorage(PrinterTypes.Guias);
      let etiquetasPrinter = readLocalStorage(PrinterTypes.Etiquetas);
      if (guiasPrinter && etiquetasPrinter)
        return true;


      let dialog = this.modalService.open(PrinterSelectionDialog, {
      }, state => {
        state.guiaPrinterRequired.set(true);
        state.etiquetaPrinterRequired.set(true);
      });
      return await dialog.result;

    });

  }

  resources = {
    get: (id: Signal<number | undefined>) => httpResource<ImpresoraDTO>(() => id() ? { url: `${environment.apiUrl}/api/impresoras/${id()}` } : undefined, { defaultValue: {} as any }),
    getList: () => httpResource<GetImpresoraListResponse[]>(() => ({ url: `${environment.apiUrl}/api/impresoras` })),
    getListFromSucursal: () => httpResource<GetImpresoraListResponse[]>(() => ({ url: `${environment.apiUrl}/api/impresoras/my-sucursal` }))
  }
}
